import React from 'react';

const DATE_INPUT_CLASS =
    'border border-yellow-300 rounded px-2 py-1 text-sm bg-yellow-100';

const AnalyticsDateRange = ({ chartFrom, setChartFrom, chartTo, setChartTo }) => (
    <div className="flex flex-wrap items-end gap-2">
        <div>
            <label className="block text-xs text-gray-500 mb-1">From (SG)</label>
            <input
                type="date"
                value={chartFrom}
                onChange={(e) => setChartFrom(e.target.value)}
                className={DATE_INPUT_CLASS}
            />
        </div>
        <div>
            <label className="block text-xs text-gray-500 mb-1">To (SG)</label>
            <input
                type="date"
                value={chartTo}
                onChange={(e) => setChartTo(e.target.value)}
                className={DATE_INPUT_CLASS}
            />
        </div>
    </div>
);

export default AnalyticsDateRange;
